import { gql } from 'apollo-angular';

const UPLOAD_REQUEST_ANALYSIS_RESULTS = gql`
  query uploadRequestAnalysisResults(
    $request: UploadRequestAnalysisResultsRequest
  ) {
    uploadRequestAnalysisResults(
      uploadRequestAnalysisResultsRequest: $request
    ) {
      url
    }
  }
`;

export default UPLOAD_REQUEST_ANALYSIS_RESULTS;
